import { render, staticRenderFns } from "./AppPromotionResultForm.vue?vue&type=template&id=4b26ae5a&"
import script from "./AppPromotionResultForm.vue?vue&type=script&lang=js&"
export * from "./AppPromotionResultForm.vue?vue&type=script&lang=js&"
import style0 from "./AppPromotionResultForm.vue?vue&type=style&index=0&id=4b26ae5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports